<script>
import { Base64 } from 'js-base64';
import { AxiosHelper } from '@src/utils/utils'
import Grid from '@components/Grid';

export default {
  components: { Grid },
  props: {
  },
  data() {
    return {
			time : new Date().getTime(),
			body : '',
			masterPrice : 0,
			msg : '',
			grid : null,
			pasteMode : '',
			details : [],


			gridOption1 : {
				columns : [
					{ data: 'category' },
					{ data:'group1' },
					{ data:'group2' },
					{ data:'detail_name' },
					{ data:'price' },
					{ data:'amount' },
					{ data:'sum' },
				],
				columnDefs : [
					{
						render : (data, type, row, meta) => {
							if(typeof data === 'number')
								return this.category[data].cate_name;
							return data;
						},
						targets : 0
					},
				],
				bInfo : false,
				"footerCallback": function ( row, data, start, end, display ) {
					var api = this.api();

					// Total over all pages
					var total = api
							.column( 6 )
							.data()
							.reduce( function (a, b) {
									return a + b;
							}, 0 );


					// Update footer
					window.$( api.column( 4 ).footer() ).html(total);
				},
			},


			editOption : {
				sourceStore : {},
				columnDefs : [
					{
						targets : 0,
						type : 'select',
						list : [],
						onEdited : function(prev, changed, index, cell) {
							cell.cell(index.row, 1).data('');
							cell.cell(index.row, 2).data('');
						}
					},
					{
						targets : 1,
						type : 'select',
						list : function(source) {
							const ret = [];
							for(const key in source.groups) {
								ret.push(key);
							}
							return ret;
						},
						onEdited : function(prev, changed, index, cell) {
							cell.cell(index.row, 2).data('');
						}
					},
					{
						targets : 2,
						type : 'select',
						list : function(source) {
							return source.groups[this.group1];
						}
					},
					{
						targets : 3
					},
					{
						targets : 4,
						type : 'number',
					},
					{
						targets : 5,
						type : 'number',
					},
				],
				onEdited : function(prev, changed, index, cell) {
					const data = cell.row(index.row).data();
					cell.cell(index.row, 6).data(data.price * data.amount);
				}
			},

    }
  },
  created() {
	},
  mounted() {},
  methods: {
    show: function(time) {
			this.details = [];
			this.pasteMode = '';

			const p1 = AxiosHelper.get(`/api/cardsms/pay/history/detail/${time}`);
			const p2 = AxiosHelper.get('/api/cardsms/group/kind');
			const p3 = AxiosHelper.get('/api/cardsms/group/category');
	
			Promise.all([p1, p2, p3]).then(([ret1, ret2, ret3]) => {
				const payInfo = ret1.data;
				const kindList = ret2.data;
				let groups = ret3.data;
	
				groups = groups.reduce(function(accum, v) {
					if(!accum[v.group1])
						accum[v.group1] = [];
		
					accum[v.group1].push(v.group2);
					return accum;
				}, []);

				this.editOption.columnDefs[0].list = kindList.map(v => {
					return {text: v.cate_name, value: v.idx};
				});

				this.editOption.sourceStore.groups = groups;
				
				this.masterPrice = payInfo.price.toInt();
				this.msg = payInfo.orgMsg;
				this.time = time;
				this.category = kindList;
				this.details = payInfo.details;
				this.groups = groups;
				this.pasteMode = '';

				if(this.details.length === 0) {
					this.addRow();
				}
			});

      this.$refs.modal.show()
		},
		
		addRow(e, item) {
			if(!item) {
				item = [{
					category:0, 
					group1:'', 
					group2:'', 
					detail_name:'', 
					price : this.masterPrice, 
					amount : 1, 
					sum:this.masterPrice
				}];
			}

			this.details = this.details.concat(item);
		},

		save() {
			let sum = 0;
			this.details.forEach(item => {
				sum += item.sum;
			});

			if(this.masterPrice !== sum) {
				alert('사용한 전체금액과 일치하지 않습니다.');
				return;
			}

			var s = encodeURIComponent(JSON.stringify(this.details));
			var encodeData = Base64.encode(s);
			AxiosHelper.post(`/api/cardsms/pay/history/detail/${this.time}/update`, {
				encodeData : encodeData
			}).then(ret => {
				this.pushMessage('저장되었습니다.');
				this.hidden({
					action : 'saved',
					time : this.time,
					detailCnt : this.details.length,
					category : this.details[0].category
				});
			});
		},
		
		removeSms() {
			if(!window.confirm('정말로 삭제할거냐?'))
				return;

			AxiosHelper.get(`/api/cardsms/pay/history/detail/${this.time}/delete`).then(ret => {
				this.pushMessage('삭제되었습니다.');
				this.hidden({
					action : 'removed',
					time : this.time
				});
			});
		},


    hidden(obj) {
			this.$refs.modal.hide()
      this.$emit('hidden', obj);
    },
  },
}
</script>

<template>
	<C.Modal ref="modal"
		title='상세내역 등록'
		dialog-class-name="modal-dialog-scrollable modal-lg"
	>
    <template v-slot:buttons>
			<button type="button" class="btn btn-primary" @click="addRow">추가</button>,
			<button type="button" class="btn btn-primary" @click="save">저장</button>,
			<button type="button" class="btn btn-danger" @click="removeSms">삭제</button>
    </template>

		<!-- <select onChange={this.setPasteMode} value={this.state.pasteMode} class="form-control">
			<option value=''>복사내역 붙여넣기</option>
			<option value='coupang'>쿠팡</option>
		</select> -->

		<C.Row>
			<dt class="col-sm-3">총액 {{masterPrice.toComma()}}원</dt>
			<dd class="col-sm-9">{{msg}}</dd>
		</C.Row>

		<Grid
			:data="details"
			:option="gridOption1" :edit-option="editOption"
		>
			<template v-slot:thead>
				<tr>
					<th>카테고리</th>
					<th>대분류</th>
					<th>중분류</th>
					<th>물품명</th>
					<th>금액</th>
					<th>수량</th>
					<th>총액</th>
				</tr>
			</template>
			<template v-slot:tfoot>
				<tr>
					<th colSpan="4" class="text-center">총합</th>
					<th colSpan="3" class="text-center"></th>
				</tr>
			</template>
		</Grid>
	</C.Modal>
</template>
